/**
 * Contact CTA Button
 *
 * Floating button that links to the on-page contact section (#main-contact)
 * or falls back to a configurable contact page. Hides when the target
 * section (or the footer, if no section exists) scrolls into view.
 *
 * Configuration is provided via window.regattaContactCta (set by PHP).
 */

const SCROLL_THRESHOLD = 400;

function createButton(label, href) {
	const btn = document.createElement('a');
	btn.className = 'contact-cta';
	btn.setAttribute('href', href);
	btn.innerHTML = label;

	document.body.appendChild(btn);
	return btn;
}

function init() {
	const config = window.regattaContactCta;
	if (!config || (!config.contactUrl && !document.querySelector('#main-contact'))) {
		return;
	}

	const contactSection = document.querySelector('#main-contact');
	const isOnPage = !!contactSection;
	const href = isOnPage ? '#main-contact' : config.contactUrl;

	if (!href) return;

	const label = config.label || 'Maak een afspraak';
	const btn = createButton(label, href);

	const hideTarget = isOnPage
		? contactSection
		: document.querySelector('footer, .site-footer, .wp-block-template-part footer');

	let targetVisible = false;

	if (hideTarget) {
		const observer = new IntersectionObserver(
			(entries) => {
				targetVisible = entries[0].isIntersecting;
				updateVisibility();
			},
			{ rootMargin: '0px 0px -80% 0px' }
		);
		observer.observe(hideTarget);
	}

	function updateVisibility() {
		const scrollY = window.scrollY || document.documentElement.scrollTop;
		const shouldShow = scrollY > SCROLL_THRESHOLD && !targetVisible;
		btn.classList.toggle('is-visible', shouldShow);
	}

	window.addEventListener('scroll', updateVisibility, { passive: true });
	updateVisibility();

	if (isOnPage) {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			if (window.lenis) {
				window.lenis.scrollTo(contactSection, { duration: 1.2, offset: -40 });
			} else {
				contactSection.scrollIntoView({ behavior: 'smooth' });
			}
		});
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
